import type { FunctionComponent } from 'react';
import React from 'react';
import type { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import type { ButtonProps } from '@material-ui/core/Button';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';

interface HelpButtonProps extends ButtonProps {
  topNavbackgroundWhite?: boolean;
}

const useStyles = makeStyles<Theme, HelpButtonProps>({
  root: {
    textTransform: 'none',
    color: '#6B7A86',
    fontWeight: 450,
    fontSize: 15,
    letterSpacing: 'normal',
    backgroundColor: 'transparent',
    padding: '0',
    '&:hover': {
      backgroundColor: '#F1F4F6',
    },
  },
});

/**
 * Help button.
 * Just a regular button with some specific styling.
 */
export const HelpButton: FunctionComponent<HelpButtonProps> = ({ topNavbackgroundWhite, ...props }) => {
  const classes = useStyles(props);

  return (
    <Box className={(classes.root, props.className)}>
      <Button {...props} className={classes.root}>
        Help
      </Button>
    </Box>
  );
};
